/**
 * ProSpin Design Tokens — copied from prospin-web/src/lib/theme.ts.
 * Keep in sync if the user-facing app changes its palette.
 */

export const PS = {
  red: '#DA291C',
  redDark: '#B01E0A',
  danger: '#c0392b',
  black: '#000000',
  surface: '#303030',
  white: '#FFFFFF',
  nearBlack: '#181818',
  textSec: '#666666',
  textTer: '#767676',
  placeholder: '#969696',
  border: '#CCCCCC',
  borderLight: '#E8E8E8',
  teal: '#1EAEDB',
  tealDeep: '#1C5F78',
  linkBlue: '#3860BE',
  success: '#03904A',
  successSoft: '#e8f8ef',
  surfaceDisabled: '#f0f0f0',
  pageSecondary: '#fafafa',
  warning: '#F13A2C',
  info: '#4C98B9',
  pageBg: '#F2F3F4',
  errorBg: '#fff0f0',
  errorBorder: '#f0a0a0',
  errorText: '#a02020',
  infoBg: '#e8f0ff',
  infoBorder: '#99b4f0',
  infoText: '#1a3a80',
  tabBg: '#e8eaeb',
  pendingBg: '#FFF3CD',
  pendingText: '#856404',
  pendingBorder: '#FFE082',
  // Tournament table blocks. A distinct hue on purpose: teal is one_time,
  // green subscription, blue credit and amber coach_block, so a tournament
  // block must not read as any of them on the booking grid.
  tournamentBg: '#EDE7F6',
  tournamentText: '#4527A0',
  tournamentBorder: '#B39DDB',
} as const;

export const T = {
  sectionTitle: { fontFamily: "'Barlow',sans-serif", fontSize: 26, fontWeight: 500, lineHeight: 1.2 },
  cardHeading:  { fontFamily: "'Barlow',sans-serif", fontSize: 24, fontWeight: 400 },
  subheading:   { fontFamily: "'Barlow',sans-serif", fontSize: 18, fontWeight: 700, lineHeight: 1.2 },
  ui:           { fontFamily: "'Barlow',sans-serif", fontSize: 16, fontWeight: 500, letterSpacing: '0.08px' },
  bodyBold:     { fontFamily: "'Barlow',sans-serif", fontSize: 16, fontWeight: 700 },
  buttonLabel:  { fontFamily: "'Barlow',sans-serif", fontSize: 16, fontWeight: 400, letterSpacing: '1.28px' },
  navLink:      { fontFamily: "'Barlow',sans-serif", fontSize: 13, fontWeight: 600, letterSpacing: '0.13px' },
  caption:      { fontFamily: "'Barlow',sans-serif", fontSize: 13, fontWeight: 400, letterSpacing: '0.195px', lineHeight: 1.5, color: '#666666' },
  label:        { fontFamily: "'Barlow Condensed',sans-serif", fontSize: 12, fontWeight: 400, letterSpacing: '1px', textTransform: 'uppercase' as const, color: '#8F8F8F' },
  microLabel:   { fontFamily: "'Barlow Condensed',sans-serif", fontSize: 11, fontWeight: 400, letterSpacing: '1px', textTransform: 'uppercase' as const, color: '#8F8F8F' },
} as const;
